/**
 * User Preferences Management
 * Handles localStorage persistence for user preferences like dark mode, language, etc.
 */

const PREFERENCES_KEY = "userPreferences";

const DEFAULT_PREFERENCES = {
  darkMode: false,
  language: "en", // Future: support for multiple languages
};

/**
 * Get all user preferences from localStorage
 */
export const getPreferences = () => {
  try {
    const stored = localStorage.getItem(PREFERENCES_KEY);
    if (stored) {
      return { ...DEFAULT_PREFERENCES, ...JSON.parse(stored) };
    }
  } catch (error) {
    console.error("Error loading preferences:", error);
  }
  return DEFAULT_PREFERENCES;
};

/**
 * Save user preferences to localStorage
 */
export const savePreferences = (preferences) => {
  try {
    localStorage.setItem(PREFERENCES_KEY, JSON.stringify(preferences));
  } catch (error) {
    console.error("Error saving preferences:", error);
  }
};

/**
 * Get a specific preference value
 */
export const getPreference = (key, defaultValue = undefined) => {
  const preferences = getPreferences();
  return preferences[key] !== undefined ? preferences[key] : defaultValue;
};

/**
 * Set a specific preference value
 */
export const setPreference = (key, value) => {
  const preferences = getPreferences();
  preferences[key] = value;
  savePreferences(preferences);
};

/**
 * Reset preferences to defaults
 */
export const resetPreferences = () => {
  try {
    localStorage.removeItem(PREFERENCES_KEY);
  } catch (error) {
    console.error("Error resetting preferences:", error);
  }
};
